import { useEffect, useRef } from 'react'
import { useChatSendOptional } from '@/features/chat/chatSendContext'

/** Continue only for connections this review card completed in this mount. */
export function useConnectedIntegrationsAnnouncement(toolkits) {
  const chat = useChatSendOptional()
  const announced = useRef(new Set())

  useEffect(() => {
    if (!chat?.sendMessage) return
    for (const toolkit of toolkits) {
      if (!toolkit || announced.current.has(toolkit)) continue
      announced.current.add(toolkit)
      chat.sendMessage({ text: `${toolkit} is connected now — please continue.`, files: [] })
    }
  }, [chat, toolkits])
}
